import React,{Component} from 'react';
import "./index.less";
import {NavBar,Toast,ListView,Icon,Modal,PullToRefresh} from "antd-mobile";
import {connect} from "react-redux";
import {dispatcherList,cancleCity,cancleCityInfo} from "../../../../../service/cityService";
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../../../common/image/wrongData.png');
const noOrder = require('../../../../../common/image/noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class CityWorking extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            showModal:false,
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
            orderId:'',
            orderTime:'',
            lineName:'',
            passagerNum:'',
            id:'',
            orderNum:'',
            refreshing: true,
            phoneModal:false,
            phoneId:'',
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                type:0
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        dispatcherList(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        this.setState({notDataLoading:0});
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
            refreshing: false,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    btnFunction = (params) =>{
        if(params === 0){
            return "待接单"
        }
        if(params === 1){
            return "待出行"
        }
        if(params === 2 || params === 3 || params === 4 || params === 6){
            return "行程中"
        }
        if(params === 7){
            return "待支付"
        }
        if(params === 8){
            return "已完成"
        }
        if(params === 99){
            return "已关闭"
        }
        if(params === 77){
            return "待支付"
        }
    }
    //提示modal
    modalShow=(id,orderNum)=>{
        this.setState({
            id:id,
            orderNum:orderNum
        })
        let params = {
            token: this.props.userInfo.token,
            data: {
                "shuntOrderid":id,
                "operatorType":1,
                "isCharge":0
            }
        }
        console.log(params)
        cancleCityInfo(params).then((res) => {
            console.log(res)
           if(res.data.code !== '0000'){
                Toast.info(res.data.msg,3)
            }
            else if(res.data.data.totalPrice > 0){
                Toast.info('该订单存在手续费！',3,this.props.history.push('/cityConfirm',{id:this.state.id,orderNum:this.state.orderNum}))
            }else if(res.data.data.totalPrice == 0){
                this.setState({
                    showModal:true
                })
            }
            }).catch(function (error) {
            console.log(error);
        });
       
    };
    delete = () =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "shuntOrderid":this.state.id,
                "operatorType": 1,
                "isCharge":1
            }
         };
         cancleCity(params)
            .then((res) => {
                console.log(res)
                // return
                 if (res.data.code === '0000') {
                    Toast.info('关闭成功',2 );  
                    pageIndex = 1;
                    let params={
                        token: this.props.userInfo.token,
                        data:{
                            pageSize: pageSize,
                            pageNum: 1,
                            type:1
                        }
                    };
                    this._getOrderList(params);
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
             }).catch(function (error) {
             console.log(error);
         });
    };
    onRefresh = () => {
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                type:0
            }
        };        
        pageIndex = 1;
        this.setState({ refreshing: true,isLoading: true, OrderListData:[]});
        setTimeout(() => {
            this._getOrderList(params);
            Toast.info('刷新成功！')
        }, 600);
    };
    goPage = (res) =>{
        console.log(res)
        if(res.status === 7){
            this.props.history.push('/cityConfirm',{type:'tobepay',orderNum:res.orderNum,id:res.id})
        }
    }
    callPhone =(e,id)=>{
        console.log(id)
        e.stopPropagation()
        this.setState({
            phoneModal:true,
            phoneId:id
        })
    }
    number=(id)=>{ 
        // let params = {
        //     token: this.props.userInfo.token,
        //     "data": {
        //         "id": id,
        //         orderSource:6,
        //     }
        // };
        // shuntFakeConverse(params).then((res) => {
        //     console.log(res)
        //     if (res.data.code === '0000') {
                window.location.href = "tel://" + id;
            // }
            // else if (res.data.code === '1401') {
            //     document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            // }
            // else {
            //     Toast.info(res.data.msg);
            // }
        // }).catch(function (error) {
        //     console.log(error);
        // });
    }
    render(){
        const _renderRow = (res, index, rowID) => (
            <div className="list" key={rowID}>
            {
                <div className="cardBox" key={rowID} onClick={()=>this.goPage(res)}>
                    <div className="header">
                        <div><span>订单号</span>{res.orderNum}</div>
                        <div>{res.cityorderType === 0 ? '实时订单':'预约订单'}</div>
                    </div>
                    <div className="body">
                        <div className="dateStatus"><span>{res.estimatedTimeOfDeparture}</span><span>{this.btnFunction(res.status)}</span></div>
                        <div className="contentBox">
                            <div>
                                <div><span><i className="icon iconfont icondaixiadanchufadi"></i></span>{res.startAddress}</div>
                                <div><span><i className="icon iconfont icondaixiadanmudedi"></i></span>{res.endAddress}</div>
                            </div>
                            <div className="phone" onClick={(e)=>this.callPhone(e,res.phone)}><i className="icon iconfont icondianhuatubiao"></i></div>
                        </div>
                    </div>
                    
                    {res.status === 1 || res.status === 2 || res.status === 3 ? 
                        <div className="footer">
                            <div className="btnBox">
                                <div className="btn gray" onClick={()=>this.modalShow(res.id,res.orderNum)}>关闭订单</div>
                            </div>  
                        </div>: null
                    }
                </div>
            }
            </div>
        )
        return(
            <div className="cityWorking">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >查看订单</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                                pullToRefresh={<PullToRefresh
                                    refreshing={this.state.refreshing}
                                    onRefresh={this.onRefresh}/>}
                            />: null
                    }        
                    <Modal
                        className="combineBillViewModal"
                        visible={this.state.showModal}
                        transparent
                        closable
                        maskClosable={true}
                        onClose={()=>this.setState({showModal:false})}
                        footer={[{ text: '否', onPress: () => {this.setState({showModal:!this.state.showModal});}},{ text: '是', onPress: () => { this.setState({showModal:!this.state.showModal});this.delete()}}]}
                    >
                    <div className="modalTitle">
                        <div>是否关闭订单？</div>
                    </div>
                    </Modal> 
                    <Modal
                        className="combineBillViewModal"
                        visible={this.state.phoneModal}
                        transparent
                        maskClosable={false}
                        footer={[{ text: '否', onPress: () => { this.setState({phoneModal:!this.state.phoneModal}); } },{ text: '是', onPress: () => { this.setState({phoneModal:!this.state.phoneModal});this.number(this.state.phoneId) } }]}
                    >
                        <div className="modalTitle">
                            <div>是否确认拨打电话？</div>
                             {/*    <span>出于隐私保护，该号码为虚拟号码</span> */}
                        </div>
                    </Modal>   
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/changeRole/City/CityWorking/index.js